document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("rusticNewsletterPopup");
    const close = document.getElementById("closeRusticPopup");

    if (!popup) return;

    const popupExpiry = localStorage.getItem("rusticNewsletterExpiry");

    if (popupExpiry && Date.now() < Number(popupExpiry)) {
        return;
    }

    setTimeout(function () {
        popup.classList.add("show");
    }, 2000);

    function closePopup() {

        popup.classList.remove("show");

        const sevenDays = 7 * 24 * 60 * 60 * 1000;

        localStorage.setItem(
            "rusticNewsletterExpiry",
            Date.now() + sevenDays
        );

    }

    if (close) {
        close.addEventListener("click", closePopup);
    }

    popup.addEventListener("click", function (e) {
        if (e.target === popup) {
            closePopup();
        }
    });

});